import ProductPriceContainer from './ProductPriceContainer';

export default ProductPriceContainer;
